import React, { Component } from "react";
import { BarChart, Bar, Cell, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { Popover } from "react-bootstrap";
import ReactDOM from "react-dom";
import Teams from "../../../../../api/Teams";

const AxisLabel = ({ axisType, x, y, width, height, stroke, children }) => {
  const isVert = axisType === "yAxis";
  const cx = isVert ? x : x + width / 2;
  const cy = isVert ? height / 2 + y : y + height + 10;
  const rot = isVert ? `270 ${cx} ${cy}` : 0;

  return (
    <text
      x={cx}
      y={cy}
      transform={`rotate(${rot})`}
      textAnchor="middle"
      stroke={stroke}
    >
      {children}
    </text>
  );
};

class VolumeChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      teamName: "",
      positionTop: 0,
      positionLeft: 0,
      showPopover: false
    };
  }

  getMaxValue(data) {
    return Math.max.apply(
      null,
      data.map(item => item.value)
    );
  }

  get domain() {
    const { unsoldInventory, unitsSold } = this.props;
    const max = Math.max(
      this.getMaxValue(unsoldInventory),
      this.getMaxValue(unitsSold)
    );

    if (max < 1000000) {
      return [0, 1000000];
    }

    return [0, "dataMax"];
  }

  get margin() {
    return {
      top: 0,
      right: 50,
      bottom: 0,
      left: 100
    };
  }

  get dataValues() {
    const { unsoldInventory, unitsSold } = this.props;
    let data = [];

    unsoldInventory.forEach(item => {
      let A = unsoldInventory.find(i => i.team === item.team);
      let B = unitsSold.find(i => i.team === item.team);

      data.push({
        team: item.team,
        "Unsold Inventory": A ? A.value : 0,
        Sales: B ? B.value : 0
      });
    });

    return data;
  }

  numberWithCommas = val => {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  onMouseLeave = () => {
    this.setState({
      showPopover: false
    });
  };

  onMouseEnter = (entry, index, e) => {
    const parentNode = ReactDOM.findDOMNode(this.refs["volume-chart"]);
    const parentCoords = parentNode.getBoundingClientRect();

    this.setState({
      showPopover: true,
      positionTop: e.clientY - parentCoords.top - 90,
      positionLeft: e.clientX - parentCoords.left - 25,
      teamName: entry.value
    });
  };

  renderPopover = () => {
    const { teamName, positionTop, positionLeft, showPopover } = this.state;

    if (showPopover === false) {
      return null;
    }

    return (
      <Popover
        id="volume-legend-popover"
        placement="top"
        positionTop={positionTop}
        positionLeft={positionLeft}
      >
        {teamName}
      </Popover>
    );
  };

  render() {
    const sales_colors = Teams.competitiveColors();
    const unsold_colors = Teams.unsoldColors();
    const { unsoldInventory, teams } = this.props;
    const payload = Object.values(teams).map((team, index) => {
      return {
        value: team,
        type: "square",
        id: `SSCID${index}`,
        color: sales_colors[index % sales_colors.length]
      };
    });

    return (
      <div id="volume-chart" ref="volume-chart">
        <BarChart
          width={450}
          height={220}
          data={this.dataValues}
          margin={this.margin}
        >
          <XAxis dataKey="team" tick={false} />
          <YAxis
            label={
              <AxisLabel axisType="yAxis" x={80} y={80} height={0}>
                # of units
              </AxisLabel>
            }
            tickFormatter={this.numberWithCommas}
            domain={this.domain}
          />
          <Tooltip />
          <Bar dataKey="Sales" barSize={18} stackId="a">
            {unsoldInventory.map((item, i) => (
              <Cell key={i} fill={sales_colors[i % sales_colors.length]} />
            ))}
          </Bar>
          <Bar dataKey="Unsold Inventory" barSize={18} stackId="a">
            {unsoldInventory.map((item, i) => (
              <Cell key={i} fill={unsold_colors[i % unsold_colors.length]} />
            ))}
          </Bar>
          <Legend
            layout="horizontal"
            align="center"
            verticalAlign="bottom"
            payload={payload}
            onMouseEnter={this.onMouseEnter}
            onMouseLeave={this.onMouseLeave}
          />
        </BarChart>
        {this.renderPopover()}
      </div>
    );
  }
}

export default VolumeChart;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/charts/volume.js